export function AdminPoll (pConfig)
{
  return (
  {
    name : 'EditorToolbarPollDescriptionLocalConfig',

    Groups :
    [
      {
        name : 'HistoryActionsMini',
        visible : true
      },

      {
        name : 'BlockActionsMiniPoll',
        visible : true
      },

      {
        name : 'TextAlignMiniPoll',
        visible : true
      },

      {
        name : 'FontColorsMiniPoll',
        visible : true
      },

      {
        name : 'TextActionsMiniPoll',
        visible : true
      },

      {
        name : 'HTMLMiniPoll',
        visible : true
      },

      {
        name : 'BlockStylesMini',
        lineBreak : true,
        visible : true
      },

      {
        name : 'TextDecoration',
        visible : true
      },

      {
        name : 'TextDecorationDropdown',
        visible : true,
        isDropdown: true
      },

      {
        name : 'BigSizeButtonsMiddle',
        visible : true
      }
    ]
  });
}